import React from "react";
import OrdersDashboard from "./OrdersDashboard";

function MakerDashboard() {
  return <OrdersDashboard userRole="Maker" />;
}

export default MakerDashboard;
